<template>
    <div class="blink-box">

    </div>
</template>

<script setup>

    import {onMounted} from "vue";

    const emits = defineEmits(["blink-complete"])

    onMounted(() => {
        setTimeout(() => {
            emits("blink-complete")
        }, 300)
    })

</script>

<style scoped>
    .blink-box {
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        z-index: 999999;
        background: #ffffff00;
        animation: animate-blink 0.25s ease-in;
    }

    @keyframes animate-blink{
        0%{
            background: #ffffff00;
        }
        25% {
            background: #ffffff;
        }
        100%{
            background: #ffffff00;
        }
    }
</style>